import React from "react";

const PipePopup = ({ feature }) => (
  <div className="custom-popup">
    <h2 className="popup-title">
      <span className="value">{feature.properties.name}</span>
    </h2>
  </div>
);

export default PipePopup;
